import React from 'react'
import { Card,CardContent,CardMedia,Typography,Box,Button, Link as LinkMui, Badge, styled } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ItemCountHorizontal from '../ItemCount/ItemCountHorizontal';
import { Edit as EditIcon } from '@material-ui/icons';
// import {config} from "../../config/config";
import {config} from "../../config/config";

import ApiQuery from "../utils/apiQuery/apiQuery"
import { CartContext } from '../CartContext/CartContext';
import ProductPurchaseInfo from '../ProductPurchaseInfo/ProductPurchaseInfo';
import fallbackImage from '../../assets/sin_imagen.jpg';
let apiQuery = new ApiQuery();

const resolveImg = (imageName) => {
  if (!imageName || imageName === 'sin_imagen.jpg') return fallbackImage;
  if (imageName.startsWith('http://') || imageName.startsWith('https://')) return imageName;
  return `${config.SERVER}/images/${imageName}`;
};

function capitalizeFirstLetter(string) {
  let cadena = String(string || '').trim().toLowerCase()
  if (!cadena) return '';
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 30,
    top: 1,
    // border: `2px solid ${theme.palette.background.paper}`,
    // padding: '10 4px',
  },
}));

const ItemHorizontal = ({product, name, description, img, stock, model,sku, price}) => {
  const cartContext = React.useContext(CartContext);
  const canViewPrice = cartContext?.canViewPrice;
  const unavailable = product?.disponibilidad === 'no disponible';
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const maxLength = 40;
  const [imgSrc, setImgSrc] = React.useState(resolveImg(img));
  const displayName = name || product?.name || 'Producto';
  const priceMissing = canViewPrice && !price;

  const handleImageError = () => {
    setImgSrc(fallbackImage);
  };

  React.useEffect(() => {
    setImgSrc(resolveImg(img));
  }, [img]);

  React.useEffect(() => {
    let cancel = false;
    apiQuery.get(`/permisos/nivel`)
    .then((respuesta)=>{
      if (cancel) return;
      setIsAdmin(respuesta)
    })
    return () => { cancel = true; }
  }, [])

  function ccyFormat(num) {
    let numFloat = parseFloat(num)
    return `${numFloat.toFixed(2)}`;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

	return (
    <>
  <Box>
  <StyledBadge 
        badgeContent={
          product.oferta === "si" && product.novedades !== "si"
            ? "OFERTA"
            : product.novedades === "si"
            ? "NOVEDADES"
            : 0
        }
        color={
          product.oferta === "si" && product.novedades !== "si"
            ? "error"
            : product.novedades === "si"
            ? "success"
            : "info"
        }
  >

  <Card sx={{ display: 'flex', width:"100%" }}>
    <Link to={`/detail/${sku}`} aria-label={`Ver detalle de ${displayName}`} style={{ display: 'flex', width: '110px', flexShrink: 0 }}>
      <CardMedia
        component="img"
        image={imgSrc}
        onError={handleImageError}
        sx={{minHeight:"110px", width:"100%", objectFit:"contain"}}
        alt={displayName}
      />
    </Link>
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
        <CardContent sx={{ flex: '1 0 auto', p: 1.5 }}>
          <Typography component="div" variant="h5" sx={{fontSize:{xs:"x-small",sm:"small",md:"medium"}}}>
            <Link to={`/detail/${sku}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              {displayName.length > maxLength
                ? (isExpanded ? capitalizeFirstLetter(displayName) : `${capitalizeFirstLetter(displayName).substring(0, maxLength)}...`)
                : capitalizeFirstLetter(displayName)}
            </Link>
            {displayName.length > maxLength && (
              <>
                <Button variant="text" size="small" onClick={(e) => {e.stopPropagation(); toggleExpanded()}} sx={{fontSize:"x-small"}}>
                  {isExpanded ? 'Leer menos' : 'Leer más'}
                </Button>
              </>
            )}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" sx={{fontSize:{xs:"x-small",sm:"small",md:"medium"}}}>
          {capitalizeFirstLetter(model)}
          </Typography>
            <Typography sx={{fontSize:{xs:"x-small",sm:"small"}}}  variant="caption" color="text.secondary">
              Código: {description}
            </Typography>
            <Typography sx={{ fontWeight: "bold", textDecoration: "none", color: unavailable || canViewPrice ? "text.primary" : "primary.main", fontSize: unavailable || canViewPrice ? {xs:"small",sm:"medium"} : {xs:"x-small",sm:"small"} }} variant="h6">
              {unavailable || priceMissing ? "No disponible" : (canViewPrice ? `$ ${ccyFormat(price)}` : "Inicie sesión para ver precio")}
            </Typography>
            {(unavailable || priceMissing) && (
              <Typography variant="caption" color="text.secondary" component="p" sx={{ m: 0.5 }}>
                Sin precio vigente. No se puede agregar al pedido.
              </Typography>
            )}
            <ProductPurchaseInfo product={product} compact />
          {isAdmin ? <>
              <LinkMui href={`${config.ADMINISTRADOR}/producto/${sku}`} target="_blank" style={{ textDecoration:"none", color:"inherit"}}>
                <Button startIcon={<EditIcon />} size="small" variant="contained" color="primary"  sx={{ fontSize: 12, mt:1}}>Editar</Button>
              </LinkMui>
            </> : <></>
          }
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', px: 1, pb: 1 }}>
        <ItemCountHorizontal
            product={product}
            initial={1}
            stock={stock}
            price={price}
          />
        </Box>
      </Box>
    </Card>
    </StyledBadge>  

  </Box>

    </>
  );
}

export default ItemHorizontal
